"use client"

import { BookAudio } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BookAudioIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BookAudioIcon = component(Icon)({ as: BookAudio })
